import { DirectivesModule } from './../directives/directives.module';
import { AuthGuard } from './_guards/auth.guard';
import { AlertService } from './alert.service';
import { ApiService } from './api.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { ReportingComponent } from './pages/reporting/reporting.component';
import { AppRoutingModule } from './/app-routing.module';
import { BladeComponent } from './blade/blade.component';
import { GeographicCategoriesComponent } from './criterias/geographic-categories/geographic-categories.component';
import { SelectListComponent } from './criterias/select-list/select-list.component';
import { RegionsComponent } from './criterias/regions/regions.component';
import { MultiSelectListComponent } from './criterias/multi-select-list/multi-select-list.component';
import { ReportSummaryComponent } from './report-summary/report-summary.component';
import { ArrayPipe } from './pipes/array.pipe';
import { OrganismCategoriesComponent } from './criterias/organism-categories/organism-categories.component';
import { OrganismsComponent } from './criterias/organisms/organisms.component';
import { DrugsComponent } from './criterias/drugs/drugs.component';
import { DrugCategoriesComponent } from './criterias/drug-categories/drug-categories.component';
import { SpecimenSourcesComponent } from './criterias/specimen-sources/specimen-sources.component';
import { SpecimenLocationsComponent } from './criterias/specimen-locations/specimen-locations.component';
import { HospitalizationsComponent } from './criterias/hospitalizations/hospitalizations.component';
import { DemographicsComponent } from './criterias/demographics/demographics.component';
import { DateCollectedComponent } from './criterias/date-collected/date-collected.component';
import { ReportingConfigComponent } from './criterias/reporting-config/reporting-config.component';
import { MatIconModule } from '@angular/material'; // this is for Angular Material Icons
import { LoadingComponent } from './loading/loading.component';
import { ProjectsComponent } from './criterias/projects/projects.component';
import { ParametricsComponent } from './criterias/parametrics/parametrics.component';
import { JsonPipe } from './pipes/json.pipe';
import { CustomComponent } from './criterias/custom/custom.component';
import { CriteriaListComponent } from './criterias/criteria-list/criteria-list.component';
import { BreakpointsComponent } from './breakpoints/breakpoints.component';
import { RequestInterceptor } from './request-interceptor';
import { MolecularComponent } from './criterias/molecular/molecular.component';
import { MolecularBladeComponent } from './criterias/molecular-blade/molecular-blade.component';
import { CriteriaValidationService } from './criteria-validation.service';
import { UserListComponent } from './admin/user-list/user-list.component';
import { UserLoginsComponent } from './admin/user-logins/user-logins.component';
import { LocalTimePipe } from './pipes/local-time.pipe';
import { SchemaAssignmentsComponent } from './admin/schema-assignments/schema-assignments.component';
import { BreakPointAdjustmentPipe } from './pipes/break-point-adjustment.pipe';
import { ScattergramChartComponent } from './scattergram/scattergram-chart/scattergram-chart.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ViewReloadComponent } from './pages/view-reload/view-reload.component';
import { PasswordResetComponent } from './pages/password-reset/password-reset.component';
import { ThemeService } from './theme.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ReportingComponent,
    BladeComponent,
    GeographicCategoriesComponent,
    SelectListComponent,
    RegionsComponent,
    MultiSelectListComponent,
    ReportSummaryComponent,
    ArrayPipe,
    OrganismCategoriesComponent,
    OrganismsComponent,
    DrugsComponent,
    DrugCategoriesComponent,
    SpecimenSourcesComponent,
    SpecimenLocationsComponent,
    HospitalizationsComponent,
    DemographicsComponent,
    DateCollectedComponent,
    ReportingConfigComponent,
    LoadingComponent,
    ProjectsComponent,
    ParametricsComponent,
    JsonPipe,
    CustomComponent,
    CriteriaListComponent,
    BreakpointsComponent,
    MolecularComponent,
    MolecularBladeComponent,
    UserListComponent,
    UserLoginsComponent,
    LocalTimePipe,
    SchemaAssignmentsComponent,
    BreakPointAdjustmentPipe,
    ScattergramChartComponent,
    ViewReloadComponent,
    PasswordResetComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    DirectivesModule,
    MatIconModule, // this is for Angular Material Icons
    NgSelectModule // this is the multi-select dropdown
  ],

  entryComponents: [
    GeographicCategoriesComponent, RegionsComponent,
    OrganismCategoriesComponent, OrganismsComponent,
    DrugCategoriesComponent, DrugsComponent,
    SpecimenSourcesComponent,
    SpecimenLocationsComponent,
    HospitalizationsComponent,
    ProjectsComponent,
    DemographicsComponent, DateCollectedComponent,
    ParametricsComponent,
    CustomComponent,
    MolecularComponent,
    MolecularBladeComponent,
    UserListComponent,

    ReportingConfigComponent,
    CriteriaListComponent,
    BreakpointsComponent,
    UserLoginsComponent,
    SchemaAssignmentsComponent,
    ScattergramChartComponent
  ], // these components must be here in order to be dynamically injected

  providers: [
    ApiService,
    AlertService,
    ThemeService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    },
    CriteriaValidationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
